import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import SmoothScroll from "./components/SmoothScroller";
import HeroSection from "./components/herosection";
import Navbar from "./components/navbar";
import BlogSection from "./pages/BlogSection";
import Blogs from "./pages/Blogs";
import BlogDetails from "./pages/BlogDetails";
import SpeechDetails from './pages/SpeechDetails';
import Speeches from './pages/Speeches';
import Infomatics from "./pages/Infomatics";
import InfomaticDetails from "./pages/InfomaticDetails";
import InfomaticsSection from "./pages/InfomaticsSection"
import ArticleSection from "./pages/ArticleSection";
import QuotesPage from "./pages/QuotesPage";
import SpeechesSection from "./pages/SpeechesSection";
import Articles from "./pages/Articles";
import ArticleDetails from "./pages/ArticleDetails";
import PhotoGallerySection from "./pages/PhotoGallerySection";
import GalleryDetail from './pages/GalleryDetails';
import VideoGallerySection from "./pages/VideoGallerySection";
import Footer from "./components/footer";
import ChatBot from "./components/ChatBot";
import { LanguageProvider } from './utils/LanguageContext';
import { trackMarathiVisit } from './services/visitTracker';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <div id="blog-section">
        <BlogSection />
      </div>
      <div id="infomatics-section">
        <InfomaticsSection />
      </div> 
      <div id="article-section">
        <ArticleSection />
      </div>
      <div id="speeches-section">
        <SpeechesSection />
      </div>
      <div id="quotes-section">
        <QuotesPage />
      </div>
      <Footer />
      <ChatBot />
    </>
  );
};

const NotFound = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-white pt-20 flex items-center justify-center">
      <div className="text-center">
        <div className="text-6xl mb-4">😕</div>
        <h2 className="text-3xl font-bold text-red-800 mb-4">Page Not Found</h2>
        <p className="text-red-600 mb-6">The page you're looking for doesn't exist.</p>
        <button 
          onClick={() => navigate('/')}
          className="bg-red-800 text-white px-6 py-2 rounded-lg hover:bg-red-900 transition-colors"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

const App = () => {
  // Track visit when app loads
  useEffect(() => {
    trackMarathiVisit();
  }, []);

  return (
    <HelmetProvider>
    <LanguageProvider>
      <Router basename={process.env.PUBLIC_URL}>
        <SmoothScroll>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/search" element={<div>Search Results</div>} />
            <Route path="/photos" element={<PhotoGallerySection />} />
            <Route path="/gallery/:id" element={<GalleryDetail />} />
            <Route path="/videos" element={<VideoGallerySection />} />
            <Route path="/allblogs" element={<Blogs />} />
            <Route path="/blog/:id" element={<BlogDetails />} />
            <Route path="/allarticles" element={<Articles />} />
            <Route path="/article/:id" element={<ArticleDetails />} />
            <Route path="/speech/:id" element={<SpeechDetails />} />
            <Route path="/allspeeches" element={<Speeches />} />
            <Route path="/allinfomatics" element={<Infomatics />} />
            <Route path="/infomatic/:id" element={<InfomaticDetails />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </SmoothScroll>
      </Router>
    </LanguageProvider>
    </HelmetProvider>
  );
};

export default App;